import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'

export class City {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public is_deleted: boolean
	@deserialize public region: ShortDataModel
}
